import { HttpApiClient, HttpClient, HttpClientRequest } from "@effect/platform";
import { Config, Context, Effect, Layer, Option, pipe, Redacted } from "effect";
import { Api } from "../api";
const DashApiClientBaseUrl = Config.string("DASH_API_CLIENT_BASE_URL").pipe(Config.withDefault("/"));
const DashApiClientApiKey = Config.option(Config.redacted("DASH_API_CLIENT_API_KEY"));
//
// Base Client
//
const make = (options)=>HttpApiClient.make(Api, {
        baseUrl: options.baseUrl,
        transformClient: (client)=>{
            const pipedClient = client.pipe(HttpClient.withSpanNameGenerator((request)=>`http.client ${request.method} ${request.url}`));
            return HttpClient.mapRequest(pipedClient, (request)=>HttpClientRequest.setHeaders({
                    ...Option.isSome(options.apiKey) ? {
                        Authorization: `Bearer ${Redacted.value(options.apiKey.value)}`
                    } : {},
                    ...options.additionalHeaders?.()
                })(request));
        }
    });
export class Client extends Context.Tag("@superwall/api/dash-api/client")() {
    static make = make;
    static Live = pipe(Config.unwrap({
        baseUrl: DashApiClientBaseUrl,
        apiKey: DashApiClientApiKey
    }), Effect.flatMap(make), Layer.effect(this));
    static layer = (options)=>pipe(make(options), Layer.effect(this));
    static layerConfig = (configOptions)=>pipe(configOptions, Config.unwrap, Effect.flatMap(make), Layer.effect(this));
}
